export default "__VITE_ASSET__DqFoJV82__"